import React, { Component } from 'react';
import { IntercomAPI } from 'react-intercom';

import Autocomplete from "react-google-autocomplete";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SpinnerComponent from "../../spinner";
import "../style/RegisterModal.scss";

import LightboxHalfScreenComponent from "../../lightboxHalfScreen/components/LightboxHalfScreenComponent";
import axios from "axios";
import querystring from "querystring";
import { withTranslation } from 'react-i18next';

class RegisterModalComponent extends Component {
    constructor(props){
        super(props);

        this.state = {
            companyType: props.companyType ? props.companyType : "",
            companyName: "",
            companyWebsite: "",
            yearEstablished: "",
            location: "",
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            locationFields: [{ glocations: null },],
            locations: [],
            registerSuccess: false,
            emailAlreadyInUse: false,
            isLoading: false,
            companyWebSiteUrl: false,
            msg: ""
        };

    }
    componentDidMount() {
        IntercomAPI('update', 'retailer_subscription');
    }
    addLocationField(){
        let state = this.state;
        state.locationFields.push({ glocations: null });

        this.setState({
            locationFields: state.locationFields
        });
    }

    handleChange(event){
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    setCompanyLocation(place, index){
        let state = this.state;
        let size = place.address_components.length
        state.locationFields[index].glocations = place.formatted_address;
        state.locations.push({'locations': String(place.address_components[size-1].long_name)})

        this.setState({
            locationFields: state.locationFields,
        });
    }

    removeLocation(index){
        let state = this.state;
        state.locationFields.splice(index, 1);
        this.setState({
            locationFields: state.locationFields
        });
    }

    pre(event) {
        event.preventDefault();
        let state = this.state;
        let formData = {
            type: state.companyType,
            company_name: state.companyName,
            company_website: state.companyWebsite,
            year_established: state.yearEstablished,
            first_name: state.firstName,
            last_name: state.lastName,
            email: state.email,
            phone: state.phone,
            locations: state.locations.map(item => item.locations),
            glocations: state.locationFields.map(item => item.glocations)
        };

        axios.post("api/preregistration/", querystring.stringify(formData), {
            headers: { "Content-Type": "application/x-www-form-urlencoded" }})
            .then((response) => {
                //console.log(response, "pre register")
                this.setState({
                    registerSuccess: true
                })

        }).catch( (error) => {
            console.log("error", error.response.data.email);

            if(error.response.data.email && error.response.data.email[0]) {
                this.setState({
                    emailAlreadyInUse: true,
                    isLoading: false
                });
            } else {
                this.setState({
                    emailAlreadyInUse: false,
                    isLoading: false
                });
            }

            if(error.response.data.company_website && error.response.data.company_website[0]) {
                this.setState({
                    companyWebSiteUrl: true,
                    isLoading: false
                });
            } else {
                this.setState({
                    companyWebSiteUrl: false
                });
            }
        });
    }

    render() {
        return (
            <LightboxHalfScreenComponent extraClass="register-lh-modal" close={this.props.close}>
                <div id="register-modal">
                    {
                        !this.state.registerSuccess &&
                        <div className="title-and-description">
                            <h2>{this.props.t("LET'S START YOUR REGISTRATION")}</h2>
                            <div className="description">
                                { this.state.companyType === "b" &&
                                    this.props.t("register_b_subtitle")}
                                { this.state.companyType === "s"  && this.props.t("register_s_subtitle")
                                }
                            </div>
                        </div>
                    }
                    <div className="registration-title-box">
                        {
                            this.state.registerSuccess ?
                                <p> {this.props.t('THANKS FOR YOUR REGISTRATION')} </p> :
                                <span className="subtitle">{this.props.t('COMPANY INFO')}</span>
                        }
                    </div>
                    <form onSubmit={this.pre.bind(this)}>
                        <div className="container">
                            {
                                !this.state.registerSuccess &&
                                <React.Fragment>
                                    <div className="company-info">
                                        <select value={this.state.companyType} name="companyType" onChange={ (event) => this.handleChange(event)}>
                                            <option value="">{this.props.t('Who are you?')}</option>
                                            <option value="b">{this.props.t('Retailer')}</option>
                                            <option value="s">{this.props.t('Brand')}</option>
                                        </select>
                                        <input disabled={!this.state.companyType} name="companyName" required value={this.state.companyName} onChange={this.handleChange.bind(this)} type="text" placeholder={this.props.t("Company Name")} />
                                        <input disabled={!this.state.companyType} name="companyWebsite" value={this.state.companyWebsite} onChange={this.handleChange.bind(this)} type="text" placeholder={this.props.t("Company Website")} />
                                        <input disabled={!this.state.companyType} name="yearEstablished" value={this.state.yearEstablished} onChange={this.handleChange.bind(this)} type="text" placeholder={this.props.t("Year Established")} />
                                        { this.state.companyType === "b" &&
                                        this.state.locationFields.map((item, index) => {
                                            return (
                                                <div key={index} className="auto-complete-group">
                                                    <Autocomplete
                                                        key={index}
                                                        style={{ width: '100%' }}
                                                        onPlaceSelected={(place) => { this.setCompanyLocation(place, index) }}
                                                        types={['(regions)']}
                                                        placeholder={this.props.t("Location of Business Operations")}
                                                    />
                                                    { index !== 0 && <FontAwesomeIcon onClick={() => this.removeLocation(index)} icon="times-circle" /> }
                                                </div>
                                            )
                                        })
                                        }
                                        { this.state.companyType === "b" &&
                                        <div onClick={() => this.addLocationField()} className="add-location">
                                            <FontAwesomeIcon icon="plus-circle" />
                                            <span>{this.props.t("add more locations")}</span>
                                        </div>
                                        }
                                    </div>
                                    <div className="contact-info">
                                        <span className="subtitle">{this.props.t('CONTACT INFO')}</span>
                                        <input disabled={!this.state.companyType} name="firstName" value={this.state.firstName} onChange={this.handleChange.bind(this)} type="text" placeholder={this.props.t("First Name")} />
                                        <input disabled={!this.state.companyType} name="lastName" value={this.state.lastName} onChange={this.handleChange.bind(this)} type="text" placeholder={this.props.t("Last Name")} />
                                        <input disabled={!this.state.companyType} name="phone" value={this.state.phone} onChange={this.handleChange.bind(this)} type="text" placeholder={this.props.t("Phone")} />
                                        <input disabled={!this.state.companyType} name="email" value={this.state.email} onChange={this.handleChange.bind(this)} type="text" placeholder={this.props.t("Email")} required/>
                                    </div>
                                    <div className="checkbox-group">
                                        <label className="receive-news-checkbox">{this.props.t('Receive news and updates from us')}
                                            <input type="checkbox" name="addEmailToList"/>
                                            <span className="checkmark" />
                                        </label>
                                    </div>
                                    <button disabled={!this.state.companyType} className="register-button" type="submit">
                                        { this.state.isLoading ? (<SpinnerComponent />) : this.props.t('SEND') }
                                    </button>

                                    <div className="email-box">
                                        {
                                            this.state.emailAlreadyInUse &&
                                            <p>
                                              {this.props.t('emailAlreadyInUse')}
                                            </p>
                                        }


                                        {
                                            this.state.companyWebSiteUrl &&
                                            <p>
                                               {this.props.t('COMPANY WEBSITE INVALID')}
                                            </p>
                                        }

                                    </div>
                                </React.Fragment>
                            }
                            {
                                this.state.registerSuccess &&
                                <div className="success-text">
                                    <FontAwesomeIcon size="2x" icon="envelope-open" />
                                    <span>{this.props.t('Check your email for more information')}</span>
                                    <button className="register-button" onClick={() => this.props.close()}>{this.props.t('GO BACK')}</button>
                                </div>
                            }

                        </div>
                    </form>
                </div>
            </LightboxHalfScreenComponent>
        );
    }

}

export default withTranslation()(RegisterModalComponent);
